"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.AppOpticsContent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("../../../../components/Grid"));

var _ActivationContent = require("./ActivationContent");

var AppOpticsTracing = "https://cdn.solarwinds.cloud/cloud-ui/assets/appoptics-tracing-b66362670164d0e91b9c7dcc9362ef8e.svg";
var AppOpticsInfrastructure = "https://cdn.solarwinds.cloud/cloud-ui/assets/appoptics-infrastructure-855fd163d617c957bd636b4a7d435267.svg";
var AppOpticsMetrics = "https://cdn.solarwinds.cloud/cloud-ui/assets/appoptics-metrics-84cc0b5225cbc5bf74ad262942d02713.svg";
var AppOpticsLogo = "https://cdn.solarwinds.cloud/cloud-ui/assets/appoptics-logo-d2015cc7b06c3826879243eb44ae8c55.svg";

var AppOpticsContent = function AppOpticsContent(_ref) {
  var productStatus = _ref.productStatus;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductLogo, {
    logo: AppOpticsLogo
  }), /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductDescription, {
    title: "Infrastructure Metrics + Code Level Visibility",
    content: "AppOptics combines APM, Infrastrucute monitoring, and custom metrics into a single dashboard."
  }), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductSection, {
    image: AppOpticsTracing,
    title: "Distributed Tracing",
    content: "Automatically follow transactions across services, identify performance bottlenecks."
  }), /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductSection, {
    image: AppOpticsInfrastructure,
    title: "Infrastructure Monitoring",
    content: "Monitor on-premise monoliths to Kubernetes in the cloud. Multiple integrations and visibility into web servers, container orchestration, and databases."
  }), /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductSection, {
    image: AppOpticsMetrics,
    title: "Custom Metrics",
    content: "Flexible, multi-dimensional API, for submitting metrics from any source."
  })), /*#__PURE__*/_react["default"].createElement(_ActivationContent.Subscription, {
    productStatus: productStatus,
    type: _ActivationContent.SUBSCRIPTION_TYPE.TRIAL
  }));
};

exports.AppOpticsContent = AppOpticsContent;